/**
 * @module Date
 */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UID } from '@models/uid.model';
import { LinksClass } from '@class/links.class';
import { DateClass } from '@class/date.class';
import { Subscription } from 'rxjs';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-dates-links-list',
  templateUrl: './dates-links-list.component.html',
  styleUrls: ['./dates-links-list.component.css']
})
export class DatesLinksListComponent implements OnInit, OnDestroy {

  @Input() links: LinksClass;

  uids: UID[];
  lastModification$sub: Subscription;
  searchLabel: string;
  color = ItemColor('rights');

  constructor() {}

  ngOnInit() {
    this.uids = this.links.list('dates').slice();

    this.lastModification$sub = this.links.lastModification$.subscribe((attribute: string) => {
      if(attribute === 'links') this.uids = this.links.list('dates').slice();
    });
  }

  ngOnDestroy() {
    this.lastModification$sub.unsubscribe();
  }

  receiveTextValue(searchLabel: string) {
    this.searchLabel = searchLabel.toLowerCase();
  }

  receiveSelected(uid: UID) {
    if(this.links.has('dates', uid)) this.links.remove('dates', uid);
    else this.links.add('dates', uid);
  }

  receiveLinkChange(replace: { from: DateClass, to: DateClass }) {
    this.links.replace('dates', replace.from.uid.value, replace.to.uid.value, replace.to);
    this.uids = this.links.list('dates').slice();
  }

}
